export default "__VITE_ASSET__Bf0Ypwuv__"